/* This is the EMIS Student Disable for primary(type=2) and secondary(type>2) school components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 82px; width: 850px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr v-if="type == 2">
            <td
              style="
                width: 280px;
                height: 56px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              បរិយាយ
            </td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ១</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ២</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ៣</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ៤</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ៥</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ៦</td>
            <td class="td-white-long-center" colspan="2">សរុប</td>
          </tr>
          <tr v-else>
            <td
              style="
                width: 280px;
                height: 56px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              បរិយាយ
            </td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ៧</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ៨</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ៩</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ១០</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ១១</td>
            <td class="td-white-long-center" colspan="2">ថ្នាក់ទី ១២</td>
            <td class="td-white-long-center" colspan="2">សរុប</td>
          </tr>
          <tr>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in disable.length" :key="row">
            <td
              :class="[
                disable[row].val + 1 ? 'td-white-long' : 'td-light-long',
              ]"
            >
              {{ disable[row].text }}
            </td>
            <!-- g1 -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[0]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[1]"
                class="number"
              />
            </td>
            <!-- g2 -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[2]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[3]"
                class="number"
              />
            </td>
            <!-- g3 -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[4]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[5]"
                class="number"
              />
            </td>
            <!-- g4 -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[6]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[7]"
                class="number"
              />
            </td>
            <!-- g5 -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[8]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[9]"
                class="number"
              />
            </td>
            <!-- g6 -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[10]"
                class="number"
              />
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <numberinput
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
                v-model="data[disable[row].val].dt[11]"
                class="number"
              />
            </td>
            <!-- Total col -->
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <div
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
              >
                {{ row1[disable[row].val] | blank }}
              </div>
            </td>
            <td :class="[disable[row].val + 1 ? 'td-white' : 'td-light']">
              <div
                v-if="
                  row != 0 &&
                  row != 2 &&
                  row != 12 &&
                  row != 14 &&
                  row != 17 &&
                  row != 19 &&
                  row != 27
                "
              >
                {{ row2[disable[row].val] | blank }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { disable } from "@/utils/ascf/commonConfig.js";
import { priLevel } from "@//utils/ascf/priConfig.js";
import { secLevel } from "@//utils/ascf/secConfig.js";
export default {
  props: ["data", "type", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      disable: disable,
      priClass: priLevel,
      secClass: secLevel,
    };
  },
  computed: {
    row1: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    row2: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 45px;
  text-align: center;
}
.td-white {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
.td-light {
  width: 45px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.td-white-long {
  width: 200px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: white;
}
.td-white-long-center {
  width: 200px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
.td-light-long {
  width: 200px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: lightgray;
}
</style>